"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var management_model_1 = __importDefault(require("./management-model"));
var attributes_1 = __importDefault(require("./attributes"));
var WebhookTriggers;
(function (WebhookTriggers) {
    WebhookTriggers["AccountConnected"] = "account.connected";
    WebhookTriggers["AccountRunning"] = "account.running";
    WebhookTriggers["AccountStopped"] = "account.stopped";
    WebhookTriggers["AccountInvalid"] = "account.invalid";
    WebhookTriggers["AccountSyncError"] = "account.sync_error";
    WebhookTriggers["MessageCreated"] = "message.created";
    WebhookTriggers["MessageOpened"] = "message.opened";
    WebhookTriggers["MessageUpdated"] = "message.updated";
    WebhookTriggers["MessageLinkClicked"] = "message.link_clicked";
    WebhookTriggers["ThreadReplied"] = "thread.replied";
    WebhookTriggers["ContactCreated"] = "contact.created";
    WebhookTriggers["ContactUpdated"] = "contact.updated";
    WebhookTriggers["ContactDeleted"] = "contact.deleted";
    WebhookTriggers["CalendarCreated"] = "calendar.created";
    WebhookTriggers["CalendarUpdated"] = "calendar.updated";
    WebhookTriggers["CalendarDeleted"] = "calendar.deleted";
    WebhookTriggers["EventCreated"] = "event.created";
    WebhookTriggers["EventUpdated"] = "event.updated";
    WebhookTriggers["EventDeleted"] = "event.deleted";
    WebhookTriggers["JobSuccessful"] = "job.successful";
    WebhookTriggers["JobFailed"] = "job.failed";
})(WebhookTriggers = exports.WebhookTriggers || (exports.WebhookTriggers = {}));
var Webhook = /** @class */ (function (_super) {
    __extends(Webhook, _super);
    function Webhook(connection, clientId, props) {
        var _this = _super.call(this, connection, clientId, props) || this;
        _this.callbackUrl = '';
        _this.state = '';
        _this.triggers = [];
        _this.initAttributes(props);
        return _this;
    }
    Webhook.prototype.pathPrefix = function () {
        return "/a/" + this.clientId;
    };
    Webhook.prototype.saveRequestBody = function () {
        var json = {};
        // We can only update the state of an existing webhook
        if (this.id) {
            json['state'] = this.state;
        }
        else {
            json['callback_url'] = this.callbackUrl;
            json['state'] = this.state ? this.state : 'active';
            json['triggers'] = Webhook.attributes.triggers.toJSON(this.triggers);
        }
        return json;
    };
    Webhook.prototype.save = function (params, callback) {
        if (params === void 0) { params = {}; }
        return _super.prototype.save.call(this, params, callback);
    };
    Webhook.collectionName = 'webhooks';
    Webhook.attributes = {
        id: attributes_1.default.String({
            modelKey: 'id',
        }),
        applicationId: attributes_1.default.String({
            modelKey: 'applicationId',
            jsonKey: 'application_id',
        }),
        callbackUrl: attributes_1.default.String({
            modelKey: 'callbackUrl',
            jsonKey: 'callback_url',
        }),
        state: attributes_1.default.String({
            modelKey: 'state',
        }),
        triggers: attributes_1.default.StringList({
            modelKey: 'triggers',
        }),
        version: attributes_1.default.String({
            modelKey: 'version',
        }),
    };
    return Webhook;
}(management_model_1.default));
exports.default = Webhook;
